export const COLORS = [
  '#3ABF77',
  '#EA4968',
  '#E4922F',
  '#1063CD',
  '#9747FF',
  '#051350',
]
